import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import {forkJoin} from 'rxjs';
import {NavService} from '../../_services/_nav.service';
import { Campania } from '../../_models/campania';
import { CampaniaService } from '../../_services/campania.service';

@Component({
  selector: 'app-campania-detalle',
  templateUrl: 'campanias-detalle.component.html'
})

export class CampaniasDetalleComponent implements OnInit {

  campania: Campania;
  carInformacionInicial = false;
  tabSeleccionado = 'CAM';
  columnas: any[];


  constructor(private campaniaService: CampaniaService,
              private route: ActivatedRoute,
              private nav: NavService,
              private location: Location) {
  }

  ngOnInit(): void {

    // Definiendo columnas datatable
    this.columnas = [
      {field: 'codigo', header: this.nav.buscarMensaje('CAMPANIA.LBL_CODIGO'), sort: false},
      {field: 'nombre', header: this.nav.buscarMensaje('CAMPANIA.LBL_NOMBRE'), sort: false},
      {field: 'fechaInicio', header: this.nav.buscarMensaje('CAMPANIA.LBL_FECHAINICIO'), sort: false},
      {field: 'fechaFin', header: this.nav.buscarMensaje('CAMPANIA.LBL_FECHAFIN'), sort: false},
    ];
    this.route.params.subscribe((params: Params) => {
      forkJoin(
        this.campaniaService.obtenerPorId(params['id'])
      ).subscribe(([campania]) => {
        this.campania = campania;
      });
    });
  }

  regresar() {
    this.location.back();
  }

  //Manejar las acciones del acordeon
  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'CAM';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'CAMC';
        break;
      }
      default: {
        break;
      }
    }
  }
}
